import {Component, Input, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {BusyService} from "./busy.service";

@Component({
    selector: 'skitbs-busy',
    template:
        `
            <div *ngIf="show | async">
                <div class="RedBack">
                    <i class="fa fa-spinner fa-spin fa-spin-pulse Blue"  [ngStyle]="{'font-size': '28px'}" style="position: fixed; top: 50%; left: 50%;"></i>
                </div>
            </div>
        `
})
export class BusyComponent implements OnInit {

    @Input() size: number = 7;
    show: Observable<boolean>;


    /**
     * Constructor
     * @param busyService
     */
    constructor(private busyService: BusyService) {
    }

    /**
     * Lifecycle.
     */
    ngOnInit() {
        this.show = this.busyService.busyObserver.asObservable();
    }

}